module.exports = __webpack_public_path__ + "85d3da8aedd093fa5ec42daf5e9cd24d.svg";